import React from "react";
import PageLayout from "../components/common/page-layout";
import AdhocPreviewBatchTool from "../components/ingestion-adhoc-preview/adhoc-preview-batch-tool";
import { RequireAuth } from "../hooks/use-auth";

/**
 * The batch onboarding-audit preview tool: upload a set of documents for one
 * company (optionally simulating the one ingesting email they share), run DE's
 * production extractor against every document as a single group, and inspect the
 * per-document decision grid and side-effect-free apply plan the V3 intake WOULD
 * produce — without touching real intake.
 */
const AdhocIngestionPreviewBatchPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        maxWidth="xl"
        subtitle="New document-extraction pipeline"
        title="Batch ingestion preview"
      >
        <AdhocPreviewBatchTool />
      </PageLayout>
    </RequireAuth>
  );
};

export default AdhocIngestionPreviewBatchPage;
